import React from "react";
import { Link } from "react-router-dom";
import { productOfTheYear } from "../../../assets/images";
import ShopNow from "../../designLayouts/buttons/ShopNow";
import Image from "../../designLayouts/Image";

const YearProduct = () => {
  return (
    <Link to="/trade">
      {/* SEO-Friendly Promotional Banner */}
      <div className="w-full h-80 mb-20 bg-[#f3f3f3] md:bg-transparent relative font-titleFont">

        {/* Product Highlight Image with ALT for SEO */}
        <Image
          className="w-full h-full object-cover hidden md:inline-block"
          imgSrc={productOfTheYear}
          alt="Best Export Product of the Year - Reliable Indian Exporter"
        />

        {/* Content Block */}
        <div className="w-full md:w-2/3 xl:w-1/2 h-80 absolute px-4 md:px-0 top-0 right-0 flex flex-col items-start gap-6 justify-center">
          
          {/* SEO-Optimized Heading */}
          <h1 className="text-3xl font-semibold text-primeColor leading-snug">
            On-Time Delivery – Trusted Global Export Services
          </h1>

          {/* Unique & Keyword Enriched Content */}
          <p className="text-base font-normal text-primeColor max-w-[620px] mr-4">
            We specialize in reliable international trade, delivering products 
            on schedule across the globe. Partner with a trusted Indian exporter 
            committed to quality, professionalism, and timely worldwide shipping.
          </p>

          {/* CTA */}
          <ShopNow label="Explore Global Trade Options" />
        </div>
      </div>
    </Link>
  );
};

export default YearProduct;
